export default "__VITE_ASSET__DBrQbTIR__"